import { getCardData, handlize, money } from "../lib/util.functions";

export default class SideCartSelectedItem extends HTMLElement {
  #abortController
  /* #variantId */

  constructor({ variantId, price, title, quantity, options, productId, customText, bundleIndex, groupIndex, connected, step, onlyForProductId }) {
    super();
    this.className = 'side-cart-selected-item';
    this.innerHTML = `
      <div class="side-cart-selected-item__title">
        <span data-title>
          ${title}
        </span>
        <div class="side-cart-selected-item__quantity" data-quantity="1"></div>
      </div>

      <div class="side-cart-selected-item__price-row">
        <div class="side-cart-selected-item__price" data-price>
          $0.00
        </div>

        <button type="button" class="side-cart-selected-item__btn" title="Delete" aria-label="Delete" data-icon="trash">
        </button>
      </div>

      <div class="side-cart-selected-item__options">
        <div class="side-cart-selected-item__options_container" data-options-container>
        </div>
        <button type="button" class="side-cart-selected-item__btn" title="Edit" aria-label="Edit" data-icon="edit">
        </button>
      </div>
    `;
    /* this.titleEl = this.querySelector('[data-title]'); */
    this.priceEl = this.querySelector('[data-price]');
    this.quantityEl = this.querySelector('[data-quantity]');
    this.trashBtn = this.querySelector('button[data-icon="trash"]');
    this.optionsContainer = this.querySelector('[data-options-container]');
    this.editOptionsBtn = this.querySelector('button[data-icon="edit"]');
    this.card = document.querySelector(`bundler-step[data-bundler-step="${step}"] product-card[data-variant-id="${variantId}"][data-group-index="${groupIndex}"]`) || document.querySelector(`bundler-step[data-bundler-step="${step}"] product-card[data-product-id="${productId}"][data-group-index="${groupIndex}"]`);
    if (connected && this.card.parentElement.dataset.onlyForProduct === this.card.parentElement.previousElementSibling.dataset.productId) {
      this.card = this.card.parentElement.previousElementSibling;
    }
    //
    this.dataset.variantId = variantId;
    this.dataset.price = price;
    this.dataset.title = handlize(title);
    this.dataset.quantity = quantity;
    this.dataset.options = options || '';
    if (customText) this.dataset.customText = customText;
    this.dataset.bundleIndex = bundleIndex;
    this.dataset.groupIndex = groupIndex;
    this.dataset.connected = connected;
    this.dataset.step = step;
    this.step = step
    this.dataset.onlyForProductId = onlyForProductId;
  }

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.trashBtn.addEventListener('click', () => this.#onDelete(), { signal });
    this.editOptionsBtn.addEventListener('click', () => this.#onEdit(), { signal });
    /* this.dataset.row = this.card.dataset.groupIndex; */
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return [
      'data-variant-id', 
      'data-price', 
      /* 'data-title',  */
      'data-quantity',
      'data-options',
      'data-custom-text'
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      /* case 'data-variant-id':
        this.#variantId = newValue;
        break; */

      case 'data-price':
        this.priceEl.textContent = money(newValue);
        /* if (newValue === '0') this.trashBtn.dataset.icon = 'none'; */
        break;

      case 'data-quantity':
        this.quantityEl.dataset.quantity = newValue;
        break;

      /* case 'data-title':
        this.titleEl.textContent = newValue;
        this.titleEl.title = newValue;
        break; */

      case 'data-options':
        this.optionsContainer.innerHTML = '';
        if (newValue && newValue !== '') {
          const arr = newValue.split('|');
          /* const names = arr[0].split(','); */
          const values = arr[1]?.split(',');
          const optionEls = [];
          values?.forEach((value,i) => {
            optionEls.push(document.createElement('DIV'));
            optionEls[i].className = 'side-cart-selected-item__options__container__item';
            optionEls[i].textContent = value;
          });
          if (arr.length) {
            this.optionsContainer.append(...optionEls);
          }
        }
        break

      case 'data-custom-text':
        if (newValue && newValue !== '') {
          const arr = newValue.split('|');
          const optionEls = [];
          arr?.forEach((value,i) => {
            optionEls.push(document.createElement('DIV'));
            optionEls[i].className = 'side-cart-main-item__options__container__item';
            optionEls[i].textContent = value;
            optionEls[i].title = value;
          });
          if (arr.length) {
            this.optionsContainer.append(...optionEls);
          }
        }
        break;
    
      default:
        break;
    }
  }

  #onDelete() {
    const event = new CustomEvent('bundlestep:event', {
      detail: { ...getCardData(this.card, 'remove', { quantity: 0, step: this.step }), replace: false },
      bubbles: true
    });
    this.card.dispatchEvent(event);
  }

  #onEdit() {
    this.card.querySelector('[data-launch-modal]')?.click();
    window.scrollTo({top:  window.scrollY + this.card.getBoundingClientRect().top });
  }
}

customElements.define('side-cart-selected-item', SideCartSelectedItem);